<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <div v-if="created" class="alert alert-success" role="status">{{ created.title }} {{$t('notifications.created')}}.</div>
          <div v-if="updated" class="alert alert-success" role="status">{{ updated.title }} {{$t('notifications.updated')}}.</div>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link v-if="retrieved && item && prevRoute && prevRoute.name === 'EXCMConsentShow'" :to="{name: 'EXCMConsentShow', params: { id: retrieved['@id'] }}" class="btn btn-default float-right">{{ $t('buttons.backToShow') }}</router-link>
          <router-link v-else-if="item" :to="{ name: 'EXCMConsentList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-header">
              <h4 class="card-title">{{$t('views.excmconsent.update.title')}} {{ item && item['title'] }}</h4>
            </div>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMConsentForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMConsentForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMConsentForm,
    Loader
  },

  data () {
    return {
      prevRoute: null,
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmconsent/update/isLoading',
      error: 'excmconsent/update/error',
      deleteError: 'excmconsent/del/error',
      deleteLoading: 'excmconsent/del/isLoading',
      created: 'excmconsent/create/created',
      deleted: 'excmconsent/del/deleted',
      retrieved: 'excmconsent/update/retrieved',
      updated: 'excmconsent/update/updated',
      violations: 'excmconsent/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMConsentList' })
    },

    updated: function (updated) {
      this.$Swal({
        title: updated.title + ' ' + this.$t('notifications.updated'),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
      this.$router.push({ name: 'EXCMConsentShow', params: { id: updated['@id'] } })
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmconsent/create/reset',
      deleteItem: 'excmconsent/del/del',
      delReset: 'excmconsent/del/reset',
      retrieve: 'excmconsent/update/retrieve',
      updateReset: 'excmconsent/update/reset',
      update: 'excmconsent/update/update',
      updateRetrieved: 'excmconsent/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmconsent ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
